import styled from 'styled-components';
import { APP_CLASSNAME_PREFIX } from '../../../../constants';

export const Title = ({ data, isMobile }) => {
  const {
    contentTitleText,
    contentTitleColor,
    contentTitleFontSize,
    contentTitleFontWeight
  } = data;

  return (
    <StyledTitle
      $color={contentTitleColor}
      $fontSize={isMobile ? 24 : contentTitleFontSize}
      $fontWeight={contentTitleFontWeight}
    >
      {contentTitleText}
    </StyledTitle>
  );
};

const StyledTitle = styled.div.attrs({
  className: `${APP_CLASSNAME_PREFIX}-title-component`
})`
  display: block;
  margin: 20px 0;
  line-height: 1.1;
  color: ${({ $color }) => $color};
  font-size: ${({ $fontSize }) => $fontSize}px;
  font-weight: ${({ $fontWeight }) => $fontWeight};
`;
